<template>
  <section class="content-current">
    <div id="tickets">
      <div
        style="direction: rtl; display: flex; border: 1px solid; padding: 20px"
      >
        <div style="width: 25%">
          <img
            width="250"
            height="57"
            src="../../../../../public/img/pdk_logo.png"
          />
        </div>
        <div style="width: 75%; display: grid; text-align: left">
          <label
            >PMS: <span>{{ ticket.pmsReserveNumber }}</span></label
          >
          <label>CRS: <span>{{ticket.reserveNumber}}</span></label>
          <label
            >Issue Date: <span>{{ ticket.shamsiDate }}</span></label
          >
        </div>
      </div>
      <div class="pass">{{ ticket.hotel.title }}</div>
      <div style="display: flex; border: 1px solid; padding: 20px">
        <div
          class="row"
          style="
            direction: rtl;
            text-align: initial;
            display: flex;
            width: 100%;
          "
          id="hotel"
        >
          <strong style="margin-bottom: 20px; margin-right: 1%; width: 100%">
          </strong>

          <label style="margin-right: 1%; width: 100%"
            ><strong>نشانی : {{ ticket.hotel.address }}</strong>
          </label>
          <br />
          <div style="display: contents" id="time">
            <label style="margin-right: 1%"
              ><strong>تاریخ پرواز:</strong>
              {{ ticket.shamsiArrivalDate }}</label
            >

            <label style="margin-right: 6%"
              ><strong>تاریخ خروج:</strong>
              {{ ticket.shamsiDepartureDate }}</label
            >
          </div>
          <br />
          <div
            style="direction: rtl; text-align: initial; margin-top: 20px"
            class="container"
          >
            <table class="table table-centered">
              <tbody>
                <tr style="border-bottom: 1px solid">
                  <td>اتاق</td>
                  <!-- <td>تعداد</td> -->
                  <td>بزرگسال</td>
                  <td>کودک</td>
                  <td></td>
                </tr>
                <tr
                  v-for="(room, index) in ticket.bookingRoomDetail"
                  :key="index"
                >
                  <td>{{ room.description }}</td>
                  <!-- <td>{{ room.pax }}</td> -->
                  <td>{{ room.adult }}</td>
                  <td>{{ room.child }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="pass">مشخصات رزرو کننده</div>

      <div
        style="
          direction: rtl;
          text-align: initial;
          border: 1px solid;
          padding: 20px;
        "
      >
        <label style="margin-right: 1%; width: 100%"
          ><span>نام و نام خانوادگی :</span>{{ ticket.customerName }}
          {{ ticket.customerLastName }}</label
        >
        <br />
        <div style="margin-right: 1%; display: contents" id="time">
          <label style="margin-right: 1%"
            ><span>شماره تماس:</span> {{ ticket.mobile }}</label
          >

          <label style="margin-right: 6%"
            ><span>پست الکترونیک:</span> {{ ticket.email }}</label
          >
        </div>
        <br />
        <label style="margin-right: 1%"><span>نشانی:</span>{{ticket.address}} </label>
        <br />
        <label style="margin-right: 1%"
          ><span>مشخصات مسافرین:</span>
          <div
            style="margin-right: 1%; display: contents"
            v-for="(passenger, index) in ticket.bookingGuest"
            :key="index"
          >
            <span>
              {{ passenger.name }} &nbsp;
              {{ passenger.lastName }}
              <span style="font-size: 13px"
                >({{ passenger.nationalId }} , )
              </span></span
            >
            <span v-if="index !== ticket.bookingGuest.length - 1">-</span>
          </div>
        </label>

        <div
          style="
            direction: rtl;
            margin-top: 3px;
            text-align: initial;
            font-size: 14px;
            padding: 15px 5px 15px 5px;
            background: #f5faf7;
          "
        >
          <strong style="margin-left: 5px">درخواست مسافر:</strong>
        <span>{{ ticket.customerRequest}}</span>
        </div>

             <label
            v-if="ticket.bookingTransfer.length > 0"
            style="margin-right: 1%"
            ><strong>اطلاعات ترانسفر:</strong>
            <div
              style="margin-right: 1%; display: contents"
              v-for="(item, index) in ticket.bookingTransfer"
              :key="index"
            >
              <label> وسیله سفر - <span>هواپیما</span></label>
              <label style="margin-right: 1%">
                تاریخ سفر - <span>{{ item.arrivalDateShamsi }}</span></label
              >
              <label style="margin-right: 1%">
                ساعت سفر - <span>{{ item.arrivalTime }}</span></label
              >
              <label style="margin-right: 1%">
                توضیحات سفر - <span>{{ item.arrivalDescription }}</span></label
              >
              <label style="margin-right: 1%">
                تاریخ برگشت - <span>{{ item.departureDateShamsi }}</span></label
              >
              <label style="margin-right: 1%">
                ساعت برگشت - <span>{{ item.departureTime }}</span></label
              >
              <label style="margin-right: 1%">
                توضیحات برگشت -
                <span>{{ item.departureDescription }}</span></label
              >
            </div>
          </label>

      </div>

      <div class="pass">قوانین و مقررات</div>
      <div
        style="
          direction: rtl;
          border: 1px solid black;
          padding: 6px;
          text-align: right;
        "
      >
        <div
          style="margin-bottom: 50px; margin-right: 1%; display: contents"
          id="time"
        >
          <label style="margin-right: 1%"
            ><span>زودترین ساعت تحویل اتاق:</span>
            {{ ticket.hotel.checkinFrom.substring(0, 5) }}</label
          >

          <label style="margin-right: 3%"
            ><span>دیرترین ساعت تخلیه اتاق :</span>
            {{ ticket.hotel.checkoutTo.substring(0, 5) }}</label
          >
          <label style="margin-right: 3%"
            ><span>مهلت کنسلی رزرو قبل از ورود :</span
            >{{ ticket.hotel.cancelTerm }}<span>روز</span>
          </label>
        </div>
        <br />
        <strong style="margin-right: 1%">میهمان گرامی : </strong>
        <p
          v-html="ticket.hotel.policy"
          style="margin-right: 1%; !important"
        ></p>
      </div>

      <div class="pass">شرایط لغو</div>
      <div style="border: 1px solid black; padding: 6px; text-align: right">
        <p
          v-html="ticket.hotel.termCond"
          style="direction: rtl; font-size: 11pt !important"
        ></p>
      </div>
         <div class="pass">خدمات هتل</div>
        <div style="border: 1px solid black; padding: 6px; text-align: right">
          <p
            v-html="ticket.hotel.voucherText"
            style="direction: rtl; font-size: 11pt !important"
          ></p>
        </div>

      <div style="direction: rtl">
        <label style="float: right; direction: rtl; font-size: 14px"
          ><span>کاربر ثبت کننده :</span>
        </label>
        <label style="float: left; direction: rtl; font-size: 13px">{{
          ticket.sourceUserName
        }}</label>
      </div>
    </div>
    <div class="divider"></div>
    <div class="row">
      <div class="col-md-12 btn-align">
        <button type="submit" class="btn btn-primary" @click="print">
          خروجی PDF
        </button>
      </div>
    </div>
  </section>
</template>


<script>
import store from "../../../../views/profile/store/index";

export default {
  name: "PdkNumber",
  store,
  components: {},
  data: function () {
    return {
      htmldata: "",
      reserveId: 0,
      path: "",
      ticket: [],
    };
  },

  mounted: function () {
    this.reserveId = this.$route.params.id;
    this.getHtmlReserveData();
  },
  methods: {
    getHtmlReserveData() {
      this.$store
        .dispatch("getHotelCrsBookingVoucher", {
          reserveId: this.reserveId,
          sourceId: localStorage.getItem("SourceIdInReport"),
        })
        .then((res) => {
          this.ticket = res;
        });
    },

    print() {
      const localOptions = {
        styles: [
        "https://dariushgroup.com/css/bootstrap.css",
          "https://unpkg.com/kidlat-css/css/kidlat.css",
          "https://dariushgroup.com/css/printTicket.css",
        ],
      };
      this.$htmlToPaper("tickets", localOptions, () => {});
    },
  },
};
</script>

<style lang="css" scoped>
.card-align {
  display: table !important;
  text-align: center;
  margin-top: 35px;
}
.display-card {
  display: table;
}
#action {
  text-align: center;
  margin-top: 20px;
}
</style>